import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DiscountRuleResponse } from '../models/discount-rule.model';
import { DrawerRegistryService } from '../../../shared/services/drawer-registry.service';

export interface DiscountRuleDrawerOptions {
  discountRuleId?: number;
  prefilledProductId?: number;
  prefilledContactId?: number;
}

@Injectable({ providedIn: 'root' })
export class DiscountRuleDrawerService {
  private readonly registry = inject(DrawerRegistryService);
  private readonly state$ = new BehaviorSubject<{ isOpen: boolean; options: DiscountRuleDrawerOptions }>({
    isOpen: false,
    options: {}
  });

  private readonly ruleSaved$$ = new Subject<DiscountRuleResponse>();

  readonly state = this.state$.asObservable();
  readonly ruleSaved$ = this.ruleSaved$$.asObservable();

  open(options: DiscountRuleDrawerOptions = {}): void {
    if (!this.state$.value.isOpen) this.registry.opened();
    this.state$.next({ isOpen: true, options });
  }

  close(): void {
    if (this.state$.value.isOpen) this.registry.closed();
    this.state$.next({ isOpen: false, options: {} });
  }

  notifySaved(rule: DiscountRuleResponse): void {
    this.ruleSaved$$.next(rule);
  }
}
